import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["coming-back-after-a-break"]!;

export function Body() {
  return (
    <>
      <p>
        A cold, a holiday, a busy month at work. Sooner or later most runners stop for a while.
        Two studies help answer what a break costs and how quickly fitness fades.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers in Dublin went through more than 15 million runs logged by about 300,000
        recreational runners who finished a marathon between 2014 and 2017. They looked for
        periods of up to 16 weeks before race day where a runner stopped training completely,
        and compared those marathons with the same runners' marathons without a break.
      </p>
      <p>
        An older and much smaller study followed seven well-trained endurance athletes who
        stopped training for 84 days. The researchers measured their heart, blood and muscles
        at several points along the way.
      </p>

      <h2>What they found</h2>
      <p>
        Short breaks were common. More than half of the marathon runners had at least one break
        of up to six days. Breaks of a week or more were linked to finishing times 5 to 8
        percent slower than the same runners' marathons without a break.
      </p>
      <p>
        In the small study, some changes showed up quickly. How much blood the heart pumped per
        beat dropped noticeably within the first two weeks. Other adaptations in the muscles
        faded more slowly and were still above untrained levels after 84 days.
      </p>

      <h2>What it means for you</h2>
      <p>
        A few days off cost little. Don't try to win them back with extra training afterwards.
        After a week or more, start again a bit below where you stopped, and build up over the
        following weeks rather than the following days. Base your next long run on what you
        have actually run in the past month, not on what you ran before the break.
      </p>
      <p>
        If you stopped because of illness or an injury, let the reason decide when you start
        again, not the calendar. When in doubt, ask a doctor or physiotherapist.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        The marathon study is observational. Runners who stopped may also have been ill or
        injured, and a gap in a training log is not always a real break. The small study looked
        at seven highly trained athletes, not recreational runners.
      </p>

      <h2>How we use it</h2>
      <p>
        When you haven't logged a run for a week or more, PX7 Training first asks whether you
        had a break and why, before it chooses your next session. Missed sessions are not added
        on top of your plan. The next runs start from the training you have actually done.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Feely et al. (2023), Estimating the cost of training disruptions on marathon
          performance.{" "}
          <a href="https://doi.org/10.3389/fspor.2022.1096124">Frontiers in Sports and Active Living</a>.
        </li>
        <li>
          Coyle et al. (1984), Time course of loss of adaptations after stopping prolonged intense
          endurance training.{" "}
          <a href="https://doi.org/10.1152/jappl.1984.57.6.1857">Journal of Applied Physiology</a>.
        </li>
      </ul>
    </>
  );
}
